import { render, staticRenderFns } from "./TextareaV2.vue?vue&type=template&id=540c9771&scoped=true&"
import script from "./TextareaV2.vue?vue&type=script&lang=ts&"
export * from "./TextareaV2.vue?vue&type=script&lang=ts&"
import style0 from "./TextareaV2.vue?vue&type=style&index=0&id=540c9771&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540c9771",
  null
  
)

export default component.exports